// extracted by mini-css-extract-plugin
export default {"FirstSection":"NewBike_FirstSection__+4WK8","Left":"NewBike_Left__VbddV","DescriptionField":"NewBike_DescriptionField__u1Ezb","ImgInput":"NewBike_ImgInput__3DQjw"};